import React, { createContext, useContext, useState } from 'react';

// Membuat Context
const ProfileContext = createContext();

// Menyediakan akses ke context
export const useProfile = () => {
  return useContext(ProfileContext);
};

// Komponen Provider untuk membungkus aplikasi dan menyediakan state global
export const ProfileProvider = ({ children }) => {
  const [profileImage, setProfileImage] = useState('assets/images/user-grid/user-grid-img13.png'); // Default gambar
  const [email, setEmail] = useState(null);
  const updateProfileImage = (newImage) => {
    setProfileImage(newImage); // Update gambar profil
  };

  const updateEmail = (newEmail) => {
    setEmail(newEmail);
  };

  return (
    <ProfileContext.Provider value={{ profileImage, email, updateEmail, updateProfileImage }}>
      {children}
    </ProfileContext.Provider>
  );
};
